<template>
  <div>
    
    <h1>API Log Report</h1>

		<!-- FILTER START -->
		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
			<h4 class="panel-title">Filter Option</h4>
			</template>
			<div class="row outerBox filterBox">
				<div class="col row">
					<div class="col-12 col-md-4">
						<label>Activity</label>
						<Multiselect
              v-if="options.type"
							:options="options.type"
							v-model="filter.type"
						/>
					</div>
					<div class="col-12 col-md-4">
						<label>Status</label>
						<Multiselect 
              v-if="options.status"
							:options="options.status.map(x => x.code)"
							:custom-label="opt => options.status.find(x => x.code == opt).label"
							v-model="filter.status"
						/>
					</div>
					<div class="col-12 col-md-4">
						<label>Date Range</label>
						<flat-pickr
							v-model="selected.date"
							:config="rangeConfig"
							placeholder="Select To Date"
						/>
					</div>
          <div class="col-12 col-md-8">
            <label for="search_by">Search By</label>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ filterOptChosen.text }}&nbsp;<i class="fas fa-caret-down"></i></button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" v-for="opt in filterOpt" @click="filterOptChosen = opt">{{ opt.text }}</a>
                </div>
              </div>
              <input v-model="keyword" type="text" class="form-control" aria-label="Text input with dropdown button" style="height: 43px;">
            </div>
          </div>
					<div class="col-md-4 row" style="display: flex; flex-direction: column; justify-content: center;">
            <button class="btn btn-primary w-100" type="button" @click="vue_universal_table.update++" style="height: 43px; margin-top:7px">
              <span class="fa fa-filter"></span>&nbsp;&nbsp;Search
            </button>
					</div>
				</div>
			</div>
		</panel>
    <!-- FILTER END -->

    <vue-universal-table
      api_url="/api/reports/log-api"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      :buttons="vue_universal_table.buttons"
      :filter="filter"
      sort_by="log_id"
      :infinite_scroll="true"
      @onRequest="openRequest"
      @onRespond="openRespond"
    ></vue-universal-table>

    <code-modal
      v-if="modal.open"
      @closeModal="modal.open = false"
      :title="modal.title"
      :data="modal.data"
    ></code-modal>

  </div>
</template>

<script>
  import moment from 'moment';
  import Multiselect  from 'vue-multiselect'
  import flatPickr from 'vue-flatpickr-component'

  import codeModal from './childComponents/codeModal';

  export default {
    data () {
		  let date = `${new moment().startOf('month').format('Y-MM-DD')} to ${new moment().endOf('month').format('Y-MM-DD')}`
      return {
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input',
          animate: !this.isRTL()
        },
        modal : {
          open : false,
          title : "API",
          data : null,
        },

        filterOpt: [
          {
            text: 'Log ID',
            value: 'log_id'
          }, {
            text: 'RQUUID',
            value: 'rquuid'
          }, {
            text: 'Engine No',
            value: 'engine_no'
          }
        ],
        filterOptChosen : {
          text: 'Log ID',
          value: 'log_id'
        },
        keyword: '',
			  options : {
          type : null,
          status : null
        },

        selected : {
				  date : date,
        },
        filter : {
          type : null,
          status: null,
          start : date.split(' to ')[0],
          end : date.split(' to ')[1],
          dealer : null,
        },

        vue_universal_table : {
          update : 0,
          fields : [
            {
              title : "Log ID",
              variable : "log_id"
            },
            {
              title : "RQUUID",
              variable : "rquuid",
              disableSort : true
            },
            {
              title : "Engine Number",
              variable : "engine_no"
            },
            {
              title : "Activity",
              variable : "activity"
            },
            // {
            //   title : "Endpoint",
            //   variable : "endpoint",
            //   disableSort : true
            // },
            // {
            //   title : "IP Address",
            //   variable : "ip_address",
            //   disableSort : true
            // },
            {
              title : "Status",
              variable : "status"
            },
            {
              title : "Time",
              variable : "created_at",
              disableSort : true
            }
          ],
          buttons : [
            {
              title : "request",
              class : "fas fa-file-export fa-lg btn-outline-primary",
              variable : "api_string"
            },
            {
              title : "respond",
              class : "fas fa-file-import fa-lg btn-outline-success",
              variable : "respond"
            }
          ],
        },
      }
    },
    components : {
      Multiselect, 
      flatPickr,

      codeModal,
    },
    mounted () {
      this.loadUniqueFilter();
    },
    watch : {
      filterOptChosen : {
        handler(){
          this.keyword = '';
          for (var i in this.filterOpt) delete this.filter[this.filterOpt[i].value];
        },
        deep : true,
      },
      keyword : {
        handler(){
          this.filter[this.filterOptChosen.value] = this.keyword
        }
      },
      'selected.date' () {
        let splitDateRange = this.selected.date.split(' to ');
        this.filter.start = splitDateRange[0]
        this.filter.end = splitDateRange[1]
      },
    },
    methods : {
      loadUniqueFilter () {
		    var user = this.$store.state.userData.userData;
        let token = "Bearer " + user.token;

        this.$http.get('/api/master/activity' , {headers : {Authorization : token}})
        .then((resp)=> {
          this.options.type = resp.data.data.map(x=>x.activity);
        })
        .catch((err) => {console.log(err)})
        // this.$http.get('/api/master/process-type')
        // .then((resp)=> {
        //   this.options.type = resp.data.data.map(x=>x.process_type);
        // })
        // .then(()=>{
        //   //Requested Hardcode by Erik (17/03/2021)
        //   this.options.type.push("vehicle claim");
        // })
        // .catch((err) => {console.log(err)})

        this.$http.get('/api/master/logs-status' , {headers : {Authorization : token}})
        .then((resp)=> {
          this.options.status = resp.data.data.map(x=>{return{
            code: x.status_code,
            label: `${x.status_code} - ${x.status_message}`
          }})
        })
        .catch((err) => {console.log(err)})
      },
      openRequest (data) {
        this.modal.title = "Request";
        // console.log(JSON.parse(data.slice(1, data.length-1)));
        this.modal.data = JSON.parse(data.slice(1, data.length-1));
        this.modal.open = true;
      },
      openRespond (data) {
        this.modal.title = "Respond";
        // console.log(JSON.parse(JSON.parse(data.slice(1, data.length-1))));
        let formattedData = JSON.parse(data.slice(1, data.length-1));

        //If after json parse is still not an object, parse it again
        this.modal.data = typeof formattedData == 'object' ? formattedData : JSON.parse(formattedData);
        this.modal.open = true;
      }
    }
  }
</script>

<style scoped>
  
</style>